const SPACING = 30;
  const COOL_COLOR   = 0xd5c8ff; // Very bright, pale lavender (base line)
  const PEAK_COLOR   = 0xeb9cff; // Neon violet/magenta (excited/peak)
  const HOT_COLOR1   = 0xffd891; // Bright pastel orange
  const HOT_COLOR2   = 0xffa76a; // Bright true orange
  const HOT_COLOR3   = 0xfbe6ff; // Near-white, super-bright purple (hot center)
  const ALPHA        = 0.16;
  const PEAK_ALPHA   = 0.74;
  const NUM_PULSES   = 13;
  const PULSE_MIN_SPEED = 190, PULSE_MAX_SPEED = 900;
  const PULSE_MIN_WAVELENGTH = 18, PULSE_MAX_WAVELENGTH = 66;
  const PULSE_MIN_AMP = 3, PULSE_MAX_AMP = 10;
  const PULSE_MIN_LEN = 90, PULSE_MAX_LEN = 230;
  const BUBBLE_RADIUS = 120;
  const BUBBLE_STRENGTH = 24;
  const HEAT_THICKNESS = 2.2;
  const BASE_THICKNESS = 1;


  let mouse = { x: -1000, y: -1000 };
  let pulses = [];

  // Utility: Lerp between colors
  function lerpColor(a, b, t) {
    let ar = (a >> 16) & 0xff, ag = (a >> 8) & 0xff, ab = a & 0xff;
    let br = (b >> 16) & 0xff, bg = (b >> 8) & 0xff, bb = b & 0xff;
    let rr = Math.round(ar + (br - ar) * t);
    let rg = Math.round(ag + (bg - ag) * t);
    let rb = Math.round(ab + (bb - ab) * t);
    return (rr << 16) | (rg << 8) | rb;
  }

  function colorForHeat(dist, flicker) {
    let t = dist / BUBBLE_RADIUS;
    if (t < 0) t = 0; if (t > 1) t = 1;
    let color;
    if (t < 0.4) {
      color = lerpColor(HOT_COLOR3, HOT_COLOR1, t / 0.4);
    } else if (t < 0.8) {
      color = lerpColor(HOT_COLOR1, HOT_COLOR2, (t - 0.4) / 0.4);
    } else {
      color = lerpColor(HOT_COLOR2, COOL_COLOR, (t - 0.8) / 0.2);
    }
    let alpha = ALPHA + (1 - t) * 0.34 * flicker;
    return { color, alpha };
  }

  function colorForPeak(ampNorm) {
    let color = lerpColor(COOL_COLOR, PEAK_COLOR, ampNorm);
    let alpha = ALPHA + (PEAK_ALPHA - ALPHA) * ampNorm;
    return { color, alpha };
  }

  // Spiky waveform: triangle plus sin + noise
  function spikeWave(x, pulse, globalPhase, t) {
    let s = Math.sin(x * pulse.freq + globalPhase);
    // Triangle wave
    let tri = 2 * Math.abs(2 * ((x * pulse.freq / Math.PI) % 1) - 1) - 1;
    // Random flick (per-pulse)
    let flick = Math.sin(x * pulse.flickFreq + pulse.flickPhase + t/160) * pulse.flickAmp;
    // Nonlinear "crunch"
    let crunch = Math.pow(Math.abs(Math.sin(x * pulse.freq * 0.5 + pulse.phase + t/110)), 1.6) * pulse.crunchSign;
    // Combine with weights (varied per-pulse)
    return (
      s * pulse.sinWeight +
      tri * pulse.triWeight +
      flick * pulse.flickWeight +
      crunch * pulse.crunchWeight
    );
  }

  const config = {
    type: Phaser.AUTO,
    width: window.innerWidth,
    height: window.innerHeight,
    transparent: true,
    parent: 'game-container',
    scene: {
      create,
      update
    }
  };

  const game = new Phaser.Game(config);

  function create() {
    this.graphics = this.add.graphics();
    this.timeElapsed = 0;

    this.input.on('pointermove', pointer => {
      mouse.x = pointer.x;
      mouse.y = pointer.y;
    });

    window.addEventListener('resize', () => {
      this.scale.resize(window.innerWidth, window.innerHeight);
    });

    // Initialize pulses
    pulses = [];
    for (let i = 0; i < NUM_PULSES; i++) {
      schedulePulse(this, Math.random() * 2);
    }
  }

  function schedulePulse(scene, delay = 0) {
    let axis = Math.random() < 0.5 ? 'vertical' : 'horizontal';
    let index = Math.floor(Math.random() * (
      axis === 'vertical'
        ? Math.ceil(scene.sys.game.config.width / SPACING) + 1
        : Math.ceil(scene.sys.game.config.height / SPACING) + 1
    ));
    let direction = Math.random() < 0.5 ? 1 : -1;
    let speed = PULSE_MIN_SPEED + Math.random() * (PULSE_MAX_SPEED - PULSE_MIN_SPEED);
    let wavelength = PULSE_MIN_WAVELENGTH + Math.random() * (PULSE_MAX_WAVELENGTH - PULSE_MIN_WAVELENGTH);
    let amplitude = PULSE_MIN_AMP + Math.random() * (PULSE_MAX_AMP - PULSE_MIN_AMP);
    let length = PULSE_MIN_LEN + Math.random() * (PULSE_MAX_LEN - PULSE_MIN_LEN);
    let tStart = scene.time.now / 1000 + delay;
    let phase = Math.random() * Math.PI * 2;
    // More waveform personality per pulse:
    let freq = Math.PI * 2 / wavelength * (0.8 + Math.random() * 1.1);
    let triWeight = 0.2 + Math.random() * 0.45;
    let sinWeight = 0.3 + Math.random() * 0.45;
    let crunchWeight = Math.random() * 0.33;
    let flickWeight = 0.1 + Math.random() * 0.33;
    let flickFreq = 0.35 + Math.random() * 1.25;
    let flickAmp = 0.2 + Math.random() * 0.8;
    let crunchSign = Math.random() < 0.5 ? 1 : -1;
    let flickPhase = Math.random() * Math.PI * 2;
    let easing = ["linear", "in", "out", "inout"][Math.floor(Math.random()*4)];
    pulses.push({
      axis, index, tStart, direction, speed, wavelength, amplitude, length, phase,
      freq, triWeight, sinWeight, crunchWeight, crunchSign, flickWeight, flickFreq, flickAmp, flickPhase, easing
    });
  }

  function bubbleWarp(x, y, time) {
    const dx = x - mouse.x;
    const dy = y - mouse.y;
    const dist = Math.sqrt(dx*dx + dy*dy);
    if (dist < BUBBLE_RADIUS) {
      const force = Math.cos((dist/BUBBLE_RADIUS) * Math.PI) * (BUBBLE_RADIUS - dist) / BUBBLE_RADIUS;
      const angle = Math.atan2(dy, dx);
      const bump = Math.sin(time*1.5 + dist/24) * 0.7 + 1;
      return {
        x: x + Math.cos(angle) * force * BUBBLE_STRENGTH * bump,
        y: y + Math.sin(angle) * force * BUBBLE_STRENGTH * bump,
        dist: dist
      };
    }
    return { x, y, dist: dist };
  }

  function ease(p, type) {
    if (type === "linear") return p;
    if (type === "in") return p * p;
    if (type === "out") return 1 - (1 - p) * (1 - p);
    if (type === "inout") return p < 0.5 ? 2*p*p : 1-2*(1-p)*(1-p);
    return p;
  }

  // Returns {offset, ampNorm}
  function audioPulseAt(pt, axis, index, time, H, W) {
    let offset = 0, maxNorm = 0;
    for (let pulse of pulses) {
      if (pulse.axis !== axis || pulse.index !== index) continue;
      let tNow = time / 1000;
      let pulseLength = (axis === 'vertical' ? H : W);
      let duration = pulseLength / pulse.speed;
      let rawProgress = (tNow - pulse.tStart) / duration;
      if (rawProgress < 0 || rawProgress > 1) continue;
      // Randomized easing for pulse progress
      let progress = ease(rawProgress, pulse.easing);
      let pulsePos = (pulse.direction > 0)
        ? progress * pulseLength
        : pulseLength - progress * pulseLength;
      let pos = axis === 'vertical' ? pt.y : pt.x;
      let distFromPulse = Math.abs(pulsePos - pos);

      if (distFromPulse < pulse.length/2) {
        let norm = 1 - (distFromPulse / (pulse.length/2));
        let globalPhase = pulse.phase + time/80;
        let spiky = spikeWave(pos, pulse, globalPhase, tNow);
        let amp = spiky * pulse.amplitude * norm;
        offset += amp;
        let thisNorm = Math.abs(amp) / (PULSE_MAX_AMP * 1.1);
        if (thisNorm > maxNorm) maxNorm = thisNorm;
      }
    }
    return { offset, ampNorm: maxNorm };
  }

  function update(time, delta) {
    this.graphics.clear();
    let W = this.sys.game.config.width;
    let H = this.sys.game.config.height;
    let now = time / 1000;

    // Update pulses and schedule new ones as needed
    for (let i = pulses.length - 1; i >= 0; i--) {
      let pulse = pulses[i];
      let pulseLength = (pulse.axis === 'vertical' ? H : W);
      let duration = pulseLength / pulse.speed;
      if ((now - pulse.tStart) > duration + 0.08) {
        pulses.splice(i, 1);
        schedulePulse(this, Math.random() * 1.0 + 0.1);
      }
    }

    // --- VERTICAL LINES ---
    for (let i = 0, x = 0; x <= W + 2; x = ++i * SPACING) {
      let prev = null, prevDist = null, prevPeak = null, prevHeat = null;
      for (let y = 0; y <= H + 2; y += 4) {
        let animX = x + Math.sin(time/550 + y/80) * 5;
        let animY = y + Math.cos(time/450 + x/60) * 3;
        let pt = bubbleWarp(animX, animY, time/600);
        let pulse = audioPulseAt(pt, 'vertical', i, time, H, W);
        pt.x += pulse.offset;
        let flicker = Math.abs(Math.sin(time/100 + pt.x*0.03 + pt.y*0.07));
        let dist = pt.dist;
        let heat = dist < BUBBLE_RADIUS ? 1 - (dist / BUBBLE_RADIUS) : 0;

        if (prev) {
          let color, alpha, thickness;
          if (heat > 0.12 && heat > (pulse.ampNorm || 0)) {
            let heatColor = colorForHeat(dist, flicker);
            color = heatColor.color;
            alpha = heatColor.alpha;
            thickness = HEAT_THICKNESS + 1.5 * heat;
          } else if ((pulse.ampNorm || 0) > 0.08) {
            let peakColor = colorForPeak(pulse.ampNorm);
            color = peakColor.color;
            alpha = peakColor.alpha;
            thickness = BASE_THICKNESS;
          } else {
            color = COOL_COLOR;
            alpha = ALPHA;
            thickness = BASE_THICKNESS;
          }
          this.graphics.lineStyle(thickness, color, alpha);
          this.graphics.beginPath();
          this.graphics.moveTo(prev.x, prev.y);
          this.graphics.lineTo(pt.x, pt.y);
          this.graphics.strokePath();
        }
        prev = pt;
        prevDist = dist;
        prevPeak = pulse.ampNorm;
        prevHeat = heat;
      }
    }

    // --- HORIZONTAL LINES ---
    for (let i = 0, y = 0; y <= H + 2; y = ++i * SPACING) {
      let prev = null, prevDist = null, prevPeak = null, prevHeat = null;
      for (let x = 0; x <= W + 2; x += 4) {
        let animY = y + Math.sin(time/600 + x/100) * 5;
        let animX = x + Math.cos(time/500 + y/60) * 3;
        let pt = bubbleWarp(animX, animY, time/700);
        let pulse = audioPulseAt(pt, 'horizontal', i, time, H, W);
        pt.y += pulse.offset;
        let flicker = Math.abs(Math.cos(time/130 + pt.x*0.01 + pt.y*0.04));
        let dist = pt.dist;
        let heat = dist < BUBBLE_RADIUS ? 1 - (dist / BUBBLE_RADIUS) : 0;

        if (prev) {
          let color, alpha, thickness;
          if (heat > 0.12 && heat > (pulse.ampNorm || 0)) {
            let heatColor = colorForHeat(dist, flicker);
            color = heatColor.color;
            alpha = heatColor.alpha;
            thickness = HEAT_THICKNESS + 1.5 * heat;
          } else if ((pulse.ampNorm || 0) > 0.08) {
            let peakColor = colorForPeak(pulse.ampNorm);
            color = peakColor.color;
            alpha = peakColor.alpha;
            thickness = BASE_THICKNESS;
          } else {
            color = COOL_COLOR;
            alpha = ALPHA;
            thickness = BASE_THICKNESS;
          }
          this.graphics.lineStyle(thickness, color, alpha);
          this.graphics.beginPath();
          this.graphics.moveTo(prev.x, prev.y);
          this.graphics.lineTo(pt.x, pt.y);
          this.graphics.strokePath();
        }
        prev = pt;
        prevDist = dist;
        prevPeak = pulse.ampNorm;
        prevHeat = heat;
      }
    }
  }